import { render, staticRenderFns } from "./RequestConfirmationView.vue?vue&type=template&id=56d035d2&"
import script from "./RequestConfirmationView.vue?vue&type=script&lang=js&"
export * from "./RequestConfirmationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports